<template>
  <suc-select-component
    v-if="options && options.length > 0"
    :title="$t('components.fields.department.title')"
    :options="options"
    label="departmentDescr"
    :form="form"
    :name="name"
  >
    <template #no-options>{{ $t("components.fields.no_options") }}</template>
  </suc-select-component>
</template>

<script>
import { SucSelectComponent, SUC_SELECT_CHANGED_EVENT, Form } from "@/components/form";

import api from "@/api/department";

export default {
  components: {
    SucSelectComponent,
  },
  props: {
    initValue: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    form: {
      type: Form,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      value: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await api.getDepartments();
      console.log("Departments API Response:", data);
      // Filter out items with null departmentCode or null departmentDescr
      this.options = data.filter(
        (item) =>
          item.departmentCode !== null &&
          item.departmentCode !== undefined &&
          item.departmentDescr !== null &&
          item.departmentDescr !== undefined
      );
      // Emit event to parent to notify about options availability
      this.$emit("options-loaded", this.options.length > 0);
      if (this.$isset(this.initValue)) {
        this.onChangeField(this.options.find((x) => x.departmentCode == this.initValue));
      }
    },
    onChangeField(option) {
      this.form[this.name] = option;
      this.$emit(SUC_SELECT_CHANGED_EVENT, this.$deepCopy(this.value));
    },
  },
};
</script>
